const PREVIEW_ATTRIBUTE_NAME = 'data-is-preview';

/**
 * Generate font stylesheet ID from fontId
 */
function getStylesheetId(fontId: string): string {
  return `font-${fontId}`;
}

/**
 * Check whether a font stylesheet already exists in the document head
 */
export function stylesheetExists(
  documentRef: Document,
  fontId: string,
  isPreview?: boolean
): boolean {
  const stylesheetNode = documentRef.getElementById(getStylesheetId(fontId));
  if (isPreview === null || isPreview === undefined) {
    return stylesheetNode !== null;
  }
  return (
    stylesheetNode !== null &&
    stylesheetNode.getAttribute(PREVIEW_ATTRIBUTE_NAME) === isPreview.toString()
  );
}

/**
 * Attach a new font stylesheet to the document head using the provided content
 */
export function createStylesheet(
  documentRef: Document,
  fontId: string,
  isPreview: boolean
): void {
  const stylesheetNode = documentRef.createElement('style');
  stylesheetNode.id = getStylesheetId(fontId);
  stylesheetNode.setAttribute(PREVIEW_ATTRIBUTE_NAME, isPreview.toString());
  documentRef.head.appendChild(stylesheetNode);
}

/**
 * Insert the provided styles in the font's <style> element (existing styles are replaced)
 */
export function fillStylesheet(
  documentRef: Document,
  fontId: string,
  styles: string
): void {
  const stylesheetId = getStylesheetId(fontId);
  const stylesheetNode = documentRef.getElementById(stylesheetId);
  if (stylesheetNode) {
    stylesheetNode.textContent = styles;
  } else {
    console.error(
      `Could not fill stylesheet: Stylesheet with ID "${stylesheetId}" not found`
    );
  }
}
